// client/src/components/stats/cbetTextureMultiBenchmarks.ts
//
// Benchmarks de CBet Flop por textura — MULTIWAY (3+ players al flop).
// Source: theoretical — consensus de coaching content moderno.
//
// Fundamental: en multiway el rango advantage del PFR se diluye con cada
// villain extra. Donde HU cbeteás 75% en dry IP, multiway cbeteás 50% como
// máximo. La regla práctica para coaching: en multiway solo cbeteás cuando
// tu MANO PROPIA puede soportar el bet (top pair+, draws fuertes), no
// porque tu RANGO sea más fuerte.
//
// Las frecuencias multiway óptimas son notoriamente difíciles de derivar
// exactamente porque los solvers tienen problemas de complejidad con 3+
// players. Estos rangos son consensus de coaching y observación práctica.

import { FlopTexture } from '../../utils/pokerStats/types';
import { Benchmark } from './benchmarks';

export const CBET_TEXTURE_MULTI_BENCHMARKS: Record<FlopTexture, Benchmark> = {
  // Dry boards: todavía cbeteás bastante porque el villain rara vez conecta
  // duro, pero no tan agresivo como HU. Range advantage diluido.
  'dry': { min: 40, max: 60, source: 'theoretical' },

  // Semi-wet: algo de equity para el villain → bajás considerablemente.
  // Solo bateás con value real + tus mejores semi-bluffs.
  'semi-wet': { min: 25, max: 40, source: 'theoretical' },

  // Wet: muy poco bluffing. Múltiples villains tienen draws/2-pair seguido.
  'wet': { min: 25, max: 40, source: 'theoretical' },

  // Paired: range advantage del PFR sigue siendo grande (más trips en su
  // rango), así que cbeteás más que en wet, pero menos que HU.
  'paired': { min: 40, max: 60, source: 'theoretical' },

  // Monotone: al menos un villain casi siempre tiene flush draw. Cbet
  // mínimo, value-only.
  'monotone': { min: 15, max: 30, source: 'theoretical' },
};

export function getCbetTextureMultiBenchmark(texture: FlopTexture): Benchmark | null {
  return CBET_TEXTURE_MULTI_BENCHMARKS[texture] || null;
}
